/**
 * Skills loader is the functionality for the category/subcategory selector for
 * the I want to Hire section.
 */

import jQuery from 'jquery';
import templater from 'lodash-es/template';
import { T_ } from '@shared/translation';
import retargetingTracking from '@shared/tracking-retargeting';
import categoryDropdownTemplate from './category-dropdown-template.html';
import subcategoryDropdownTemplate from './subcategory-dropdown-template.html';

export default {
  $project_categories: jQuery('#project-categories-intro'),
  $category_skill: jQuery('#category-skill-intro'),
  init() {
    this.ajax_call(null); // load initial categories
    this.render_category_skills();
    this.select_state_manager();
  },

  ajax_call(category) {
    jQuery.ajax({
      type: 'GET',
      url: '/ajax/skill-bundle.php',
      dataType: 'json',
      data: { category },
      cache: true,
      success: data => {
        if (category === null) {
          this.category_template_handler(data);
        } else {
          this.skills_template_handler(data);
        }
      },
    });
  },

  category_template_handler(data) {
    const compiledTemplate = templater(categoryDropdownTemplate)({
      options: data,
      T_,
    });
    this.$project_categories.html(compiledTemplate);
  },

  skills_template_handler(data) {
    const compiledTemplate = templater(subcategoryDropdownTemplate)({
      options: data,
      T_,
    });
    this.$category_skill.html(compiledTemplate);
  },

  select_state_manager() {
    this.$category_skill.hide();

    this.$project_categories.on('change', () => {
      const selectedValue = this.$project_categories.val();
      retargetingTracking.trackMappedCategory(selectedValue);

      if (selectedValue > -1) {
        this.render_category_skills();

        if (this.$category_skill.is(':hidden')) {
          this.$category_skill.show().addClass('active');
        }
      } else if (this.$category_skill.is(':visible')) {
        this.$category_skill.removeClass('active').hide();
      }
    });
  },

  render_category_skills() {
    const value = this.$project_categories.find(':selected').val();

    if (value > -1) {
      this.ajax_call(value);
    }
  },
};
